import { useI18n } from "../lib/i18n";
import { GALLERY } from "../lib/content";

export default function Gallery() {
  const { t } = useI18n();

  return (
    <>
      <section className="pt-16 md:pt-24 pb-10" data-testid="gallery-hero">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="overline">{t("gallery.overline")}</div>
          <h1 className="mt-5 text-5xl md:text-7xl leading-[1.02] max-w-3xl">
            {t("gallery.title")}
          </h1>
          <p className="mt-6 text-lg text-[#5C5042]">{t("gallery.subtitle")}</p>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
            {GALLERY.map((g, i) => (
              <div
                key={g.src}
                data-testid={`gallery-item-${i}`}
                className={`img-zoom relative overflow-hidden ${
                  g.tall ? "row-span-2 h-[440px] md:h-[720px]" : "h-[220px] md:h-[350px]"
                }`}
              >
                <img
                  src={g.src}
                  alt={g.alt}
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
